import { v4 as uuidv4 } from 'uuid'

import { formatDate, StringDateRange } from '@/shared/lib'

export type KeywordSearchHistory = {
  id: string
  keyword: string
  startDate: string
  endDate: string
}

const DEFAULT_KEYWORD = ''

const DEFAULT_DATE_RANGE_FIELDS = {
  startDate: '',
  endDate: '',
}

const getDateRangeFields = (dateRange?: StringDateRange) => {
  if (!dateRange) {
    return DEFAULT_DATE_RANGE_FIELDS
  }

  return {
    startDate: formatDate({ date: dateRange.from, format: 'yyyy-MM-dd' }),
    endDate: formatDate({ date: dateRange.to, format: 'yyyy-MM-dd' }),
  }
}

export const convertToSearchHistory = (
  keyword: string,
  dateRange?: StringDateRange,
): KeywordSearchHistory => {
  return {
    id: uuidv4(),
    keyword: keyword || DEFAULT_KEYWORD,
    ...getDateRangeFields(dateRange),
  }
}
